import React, { useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import {
  amber,
  blue,
  blueGrey,
  brown,
  cyan,
  deepOrange,
  deepPurple,
  green,
  grey,
  indigo,
  lightBlue,
  lightGreen,
  lime,
  orange,
  pink,
  purple,
  red,
  teal,
  yellow,
} from '@mui/material/colors';
import { useUpdateEffect } from 'react-use';
import { alpha } from '@mui/material';

ChartJS.register(ArcElement, Tooltip, Legend);

// blue-lightBlue-cyan-teal-green-lightGreen-lime-yellow-amber-orange-deepOrange-brown-grey-blueGrey-indigo-deepPurple-purple-pink-red

const PieChart = ({ textColor, data12 }) => {
  const [data, setData] = useState({
    labels: [],
    datasets: [],
  });

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
        align: 'start',
        labels: {
          color: textColor,
          boxWidth: 16,
          boxHeight: 16,
          padding: 8,
        },
      },
    },
  };

  useUpdateEffect(() => {
    if (data12) {
      const { labels, data: ds } = data12;
      const datasets = [
        {
          data: ds,
          backgroundColor: [
            alpha(blue[500], 0.7),
            alpha(lightBlue[500], 0.7),
            alpha(cyan[500], 0.7),
            alpha(teal[500], 0.7),
            alpha(green[500], 0.7),
            alpha(lightGreen[500], 0.7),
            alpha(lime[500], 0.7),
            alpha(yellow[500], 0.7),
            alpha(amber[500], 0.7),
            alpha(orange[500], 0.7),
            alpha(deepOrange[500], 0.7),
            alpha(brown[500], 0.7),
            alpha(grey[500], 0.7),
            alpha(blueGrey[500], 0.7),
            alpha(indigo[500], 0.7),
            alpha(deepPurple[500], 0.7),
            alpha(purple[500], 0.7),
            alpha(pink[500], 0.7),
            alpha(red[500], 0.7),
            alpha(red[300], 0.7),
            alpha(pink[300], 0.7),
            alpha(purple[300], 0.7),
            alpha(deepPurple[300], 0.7),
            alpha(indigo[300], 0.7),
            alpha(blueGrey[300], 0.7),
            alpha(grey[300], 0.7),
            alpha(brown[300], 0.7),
          ],
          hoverBackgroundColor: [
            blue[500],
            lightBlue[500],
            cyan[500],
            teal[500],
            green[500],
            lightGreen[500],
            lime[500],
            yellow[500],
            amber[500],
            orange[500],
            deepOrange[500],
            brown[500],
            grey[500],
            blueGrey[500],
            indigo[500],
            deepPurple[500],
            purple[500],
            pink[500],
            red[500],
            red[300],
            pink[300],
            purple[300],
            deepPurple[300],
            indigo[300],
            blueGrey[300],
            grey[300],
            brown[300],
          ],
          borderWidth: 1,
          hoverOffset: 4,
        },
      ];
      setData({ labels, datasets });
    }
  }, [data12]);

  return (
    <Pie
      data={data}
      options={options}
      onMouseDown={(e) => e.stopPropagation()}
    />
  );
};

export default PieChart;
